import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { environment } from 'environments/environment';
import 'zone.js';
import * as Sentry from '@sentry/angular';
import { maskBreadcrumb, maskEvent } from 'Shared/app/core/sentry-personnummer';
import { isFromInjectedScript } from 'Shared/app/core/sentry-injected-script';

if (environment.production) {
  enableProdMode();
}

// Remove if statement and add dsn to enable Sentry in debug mode
if (environment.wfEnvironment !== 'debug' || environment.sentryDsn !== '') {
  Sentry.setTags({
    'wf.instance': environment.sentryInstance,
    'wf.environment': environment.sentryEnvironment
  });

  Sentry.init({
    dsn: environment.sentryDsn,
    integrations: [],
    beforeBreadcrumb: maskBreadcrumb,
    beforeSend: (event) => (isFromInjectedScript(event) ? null : maskEvent(event)),
    tracesSampleRate: 0,
    release: environment.wfVersion,
    environment: environment.wfEnvironment
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
